/* HotDawgs — hero Three.js scene
   Ambient embers rising over the hero photo. Decorative only. */

(function () {
  const canvas = document.getElementById('hero-canvas');
  if (!canvas || typeof THREE === 'undefined') return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 0.1, 100);
  camera.position.set(0, 0, 13);

  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(window.innerWidth, window.innerHeight);

  // Ember particles -----------------------------------------------------------
  function makeEmberTexture() {
    const size = 64;
    const c = document.createElement('canvas');
    c.width = c.height = size;
    const ctx = c.getContext('2d');
    const g = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
    g.addColorStop(0, 'rgba(255,220,180,1)');
    g.addColorStop(0.35, 'rgba(255,106,0,0.9)');
    g.addColorStop(1, 'rgba(255,106,0,0)');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, size, size);
    return new THREE.CanvasTexture(c);
  }

  const EMBER_COUNT = window.innerWidth < 700 ? 110 : 260;
  const emberGeo = new THREE.BufferGeometry();
  const positions = new Float32Array(EMBER_COUNT * 3);
  const speeds = new Float32Array(EMBER_COUNT);
  const drifts = new Float32Array(EMBER_COUNT);

  for (let i = 0; i < EMBER_COUNT; i++) {
    positions[i * 3] = (Math.random() - 0.5) * 24;
    positions[i * 3 + 1] = (Math.random() - 0.5) * 16 - 4;
    positions[i * 3 + 2] = (Math.random() - 0.5) * 10 + 2;
    speeds[i] = 0.012 + Math.random() * 0.03;
    drifts[i] = Math.random() * Math.PI * 2;
  }
  emberGeo.setAttribute('position', new THREE.BufferAttribute(positions, 3));

  const emberMat = new THREE.PointsMaterial({
    size: 0.5,
    map: makeEmberTexture(),
    transparent: true,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
    opacity: 0.95,
  });
  const embers = new THREE.Points(emberGeo, emberMat);
  scene.add(embers);

  // Subtle mouse parallax -----------------------------------------------------
  let targetX = 0, targetY = 0;
  window.addEventListener('pointermove', (e) => {
    targetX = (e.clientX / window.innerWidth - 0.5) * 1.4;
    targetY = (e.clientY / window.innerHeight - 0.5) * 1.4;
  });

  window.addEventListener('resize', () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
  });

  let t = 0;
  function animate() {
    requestAnimationFrame(animate);
    t += prefersReducedMotion ? 0.0015 : 0.006;

    if (!prefersReducedMotion) {
      const posAttr = emberGeo.getAttribute('position');
      for (let i = 0; i < EMBER_COUNT; i++) {
        let y = posAttr.getY(i) + speeds[i];
        let x = posAttr.getX(i) + Math.sin(t + drifts[i]) * 0.004;
        if (y > 9) y = -9;
        posAttr.setY(i, y);
        posAttr.setX(i, x);
      }
      posAttr.needsUpdate = true;
    }

    camera.position.x += (targetX - camera.position.x) * 0.03;
    camera.position.y += (-targetY - camera.position.y) * 0.03;
    camera.lookAt(0, 0, 0);

    renderer.render(scene, camera);
  }
  animate();
})();
